import React from 'react';
import type {RouteTarget} from '../services/routeCommunity';
import PhotoCaptureFlow from './PhotoCaptureFlow';
import type {CapturedPhotoFile} from './PhotoCaptureFlow';

interface QuickCapturePhotoSheetProps {
  onCancel: () => void;
  onNavigate?: () => void;
  onComplete: (result?: { summary?: string; photoId?: string }) => void;
  preflightCameraPermission?: PermissionState | null;
  initialMapFeatureId?: string;
  routeTarget?: RouteTarget;
  initialFiles?:CapturedPhotoFile[];
  initialFarmId?:string;
}

const QuickCapturePhotoSheet: React.FC<QuickCapturePhotoSheetProps> = ({ onCancel, onNavigate, onComplete, preflightCameraPermission = null, initialMapFeatureId = '', routeTarget,initialFiles,initialFarmId }) => {
  return (
    <PhotoCaptureFlow
      onCancel={onCancel}
      onNavigate={onNavigate}
      onComplete={onComplete}
      preflightCameraPermission={preflightCameraPermission}
      completionMessage="Photo added."
      initialMapFeatureId={initialMapFeatureId}
      routeTarget={routeTarget}
      initialFiles={initialFiles}
      initialFarmId={initialFarmId}
    />
  );
};

export default QuickCapturePhotoSheet;
